import { useContext } from 'react'
import { AppBarContext } from './AppBarProvider'

export function useAppBar() {
  const appBarContext = useContext(AppBarContext)

  if (!appBarContext) throw new Error('AppBarContext has to be used within <AppBarContext.Provider>')

  return appBarContext
}
